export default __webpack_public_path__ + "static/media/esim_logo.bdd54f7e.png";